export default {
    slug: 'timebank',
    ability: 'timebank',
    routes: [
        {
            // The per-customer view is this same list filtered — `time-bank?customer_id=X`,
            // which is what the customer record links to.
            path: 'time-bank',
            name: 'timebank-list',
            component: () => import('@modules/TimeBank/Resources/js/pages/List.vue')
        }
    ],
    nav: () => ({
        section: 'sales',
        items: [
            {
                title: i18n.t('Time Bank'),
                icon: 'timer-sand',
                to: { name: 'timebank-list' }
            }
        ]
    }),
    widgets: () => [
        {
            id: 'time-bank',
            label: i18n.t('Time Bank'),
            icon: 'clock-outline',
            component: () => import('@modules/TimeBank/Resources/js/widgets/TimeBank.vue'),
            size: 'is-4'
        }
    ]
};
